module.exports = __webpack_public_path__ + "static/media/project4.38c1b60b.png";